import { motion } from "framer-motion";
import { FaPhone } from "react-icons/fa";
import {
  Form,
  Link,
  json,
  redirect,
  useActionData,
  useNavigation,
} from "react-router-dom";
import React, { useState } from "react";
import { PulseLoader } from "react-spinners";

const inputClasses =
  "w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-gray-400 focus:ring-0 outline-none transition-colors duration-200";

function OtpSignupForm() {
  const navigation = useNavigation();
  const isSubmitting = navigation.state === "submitting";
  const data = useActionData();

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="w-full max-w-md"
      >
        <div className="p-8">
          <h2 className="text-4xl font-semibold text-center mb-8 text-gray-900">
            Register
          </h2>

          <form method="POST" className="space-y-6">
            {data?.message && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                className="p-3 bg-red-50 text-red-600 text-sm rounded-lg"
              >
                {data.message}
              </motion.div>
            )}

            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Phone Number
              </label>
              <motion.input
                whileFocus={{ scale: 1.01 }}
                type="tel"
                id="phone"
                inputMode="numeric"
                name="phone"
                required
                minLength={10}
                maxLength={10}
                className={inputClasses}
                placeholder="Enter your phone number"
              />
            </div>

            <motion.button
              whileHover={{ scale: 1.01 }}
              whileTap={{ scale: 0.98 }}
              disabled={isSubmitting}
              type="submit"
              className="w-full py-3 bg-black text-white rounded-lg font-medium hover:bg-gray-900 transition-colors duration-200"
            >
              {isSubmitting ? (
                <div className="flex justify-center items-center space-x-2">
                  <div className="w-1.5 h-1.5 bg-white rounded-full animate-bounce" />
                  <div
                    className="w-1.5 h-1.5 bg-white rounded-full animate-bounce"
                    style={{ animationDelay: "0.2s" }}
                  />
                  <div
                    className="w-1.5 h-1.5 bg-white rounded-full animate-bounce"
                    style={{ animationDelay: "0.4s" }}
                  />
                </div>
              ) : (
                "Continue"
              )}
            </motion.button>
          </form>

          <p className="text-center mt-8 text-gray-600">
            Already have an account?{" "}
            <Link
              to="/login"
              className="text-blue-600 hover:text-blue-700 font-medium"
            >
              Sign in
            </Link>
          </p>
        </div>
      </motion.div>
    </div>
  );
}

export default OtpSignupForm;

export async function signupAction({ request, params }) {
  const formData = await request.formData();
  const userData = {
    phoneNumber: formData.get("phone"),
  };

  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/otp/register`,
      {
        method: "POST",
        body: JSON.stringify(userData),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 500 || response.status === 404) {
      return response;
    }

    const resData = await response.json();

    if (!response.ok) {
      throw new Error(resData.message || "Field to Register user.");
    }
  } catch (err) {
    throw json(
      { message: "Field to register,   please try again later." },
      { status: 500 }
    );
  }
  return redirect("/login");
}
